<div class="card card-default">
  <div class="card-header">
    <h3 class="card-title">Criteria</h3>

    <div class="card-tools">
      <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>

    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body">

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label class="col-lg-4 control-label"> <b translate>ประเภทสมาชิก</b></label>

          <div class="col-lg-8">
            <select id="ddlMemberType" class="form-control">
            </select>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label class="col-lg-4 control-label"> <b translate>สถานะ</b></label>

          <div class="col-lg-8">
            <select id="ddlStatus" class="form-control">
              <option translate value="-99">ทั้งหมด</option>
              <option translate value="1">ใช้งาน</option>
              <option translate value="0">ไม่ใช้งาน</option>
            </select>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- /.card-body -->
  <div class="card-footer">
    <button type="button" class="btn btn-primary pull-right" (click)="BeforeSearch()" role="view" translate>
      <i class="fa  fa-search"></i>&nbsp;Search
    </button>
  </div>
</div>
<!-- /.card -->

<div class="card card-default">
  <div class="card-header">
    <h3 class="card-title">Data</h3>

    <div class="card-tools">
      <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>

    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body">
    <div>
      <button type="button" class="btn btn-default" role="add" (click)="Add()" translate>
        <i class="fas fa-plus colorgreen"></i>&nbsp;เพิ่ม
      </button>
      <button type="button" class="btn btn-default" role="edit" (click)="Edit()">
        <i class="fas fa-edit coloryellow"></i>&nbsp;<span translate>แก้ไข</span>
      </button>
    </div>
    <br/>
    <div id="divData">
      <table id="tData" class="table table-bordered  table-hover">
        <thead>
          <tr>
            <th width="10%" translate>รหัสประเภทสมาชิก</th>
            <th width="20%" translate>ประเภทสมาชิก</th>
            <th width="10%" translate>สถานะ</th>
            <th width="10%" translate>วันที่แก้ไข</th>
            <th width="10%" translate>ผู้แก้ไข</th>
            <th width="10%" translate>ลบ</th>
          </tr>
        </thead>
        <tbody>
        </tbody>
      </table>
    </div>
  </div>

</div>
<!-- /.card -->





<div class="container">
  <div class="modal fade" id="dlgData" role="dialog">
    <div class="modal-dialog modal-xl">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">
                <span translate>ประเภทสมาชิก</span>
              </h4>
          <button type="button" class="close" id="btnCloseDlg" data-dismiss="modal">&times;</button>
         
        </div>
        <div class="modal-body">
          <input type="text" id="txtMode" class="form-control" style="display: none;" />
          <div class="form-horizontal">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-6 control-label required"> <b translate>รหัสประเภทสมาชิก</b></label>

                  <div class="col-lg-6">
                    <input type="text" id="txtDlgID" required class="form-control" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-6 control-label required"> <b translate>ประเภทสมาชิก</b></label>

                  <div class="col-lg-6">
                    <input type="text" id="txtDlgDesc" required class="form-control" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-6 control-label required"> <b translate>สถานะ</b></label>

                  <div class="col-lg-6">
                    <select id="ddlDlgStatus" class="form-control">
                      <option translate value="1">ใช้งาน</option>
                      <option translate value="0">ไม่ใช้งาน</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">ยกเลิก</button>
          <button type="button" class="btn btn-primary " role="edit" (click)="Save()">บันทึก</button>
        </div>

      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/member/membertype/membertype.component.html